import FeaturesSection from "shared/components/home/featuresSection";
import ImageSection from "shared/components/home/imageSection";
import QuestionaireSection from "shared/components/home/questionaireSection";
import Section1 from "shared/components/home/section1";
import SecuritySection from "shared/components/home/securitySection";

const Home = () => {
  return (
    <main style={{ overflowX: "hidden", position: "relative", zIndex: "2" }}>
      <Section1 />
      <ImageSection />
      <QuestionaireSection />
      <FeaturesSection />
      {/* <TestimonialsSection /> */}
      {/* <ImpactSection /> */}
      <SecuritySection />
    </main>
  );
};

export default Home;
